/**
 * ToastText component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ToastText = styled.span`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  text-align: center;
`;

export default ToastText;
